import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserRegistration } from 'src/app/user/model/user-registration';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService
{

  constructor(private http: HttpClient) { }

  /**
   * Validate User Registration Token.
   *
   * @param data Token to check
   */
  public validateRegistrationToken(data: UserRegistration): Observable<any>
  {
    return this.http.post('/unauthenticated/registration/validate', data);
  }

  /**
   * Register the User account by setting the username, password and enabling the account.
   *
   * @param data Data to save
   */
  public registerUser(data: UserRegistration): Observable<any>
  {
    return this.http.post('/unauthenticated/registration/user', data);
  }

  /**
   * Check if the username exists.
   *
   * @param username Username to validate
   */
  public usernameExists(username: string): Observable<any>
  {
    return this.http.get<any>(`/unauthenticated/registration/user/${username}/exists`);
  }

  /**
   * Check if the email exists.
   *
   * @param email Email to validate
   */
  public emailExists(email: string): Observable<any>
  {
    return this.http.get<any>(`/unauthenticated/registration/email/${email}/exists`);
  }

  /**
   * Send request of password reset for the user
   *
   * @param data Password to reset
   * @returns Observable<object> HTTP observable response.
   */
  public resetPassword(data: UserRegistration): Observable<any>
  {
    return this.http.post('/unauthenticated/registration/resetpassword', data);
  }
}
